/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { CreateFragmentUploadMutationRequest, CreateFragmentUploadMutationResponse, CreateFragmentUploadPathParams } from "../models/CreateFragmentUpload";

export function getCreateFragmentUploadUrl(fragment: CreateFragmentUploadPathParams["fragment"]) {
  const res = { method: 'POST', url: `/upload/fragments/${fragment}` as const }
  return res
}

/**
 * @summary Start upload of fragment media to platform
 * {@link /upload/fragments/:fragment}
 */
export async function createFragmentUpload(fragment: CreateFragmentUploadPathParams["fragment"], data: CreateFragmentUploadMutationRequest, config: Partial<RequestConfig<CreateFragmentUploadMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateFragmentUploadMutationResponse, ResponseErrorConfig<Error>, CreateFragmentUploadMutationRequest>({ method : "POST", url : getCreateFragmentUploadUrl(fragment).url.toString(), data : requestData, ... requestConfig })
  return res.data
}